/*
 *  I14V2VREGULI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 16:48:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I14V2VREGUL_SECTION_0_TITLE: 'Dimensionnez votre vanne 2 voies en fonction du Kvs et de votre installation',
  I14V2VREGUL_in_kvVanne: 'KVs De la vanne V2V',
  I14V2VREGUL_in_debitCircuit: 'Débit du circuit',
  I14V2VREGUL_SECTION_1_TITLE: '',
  I14V2VREGUL_perteCharg_uuid: 'Unité de calcul de la perte de charge',
  I14V2VREGUL_res_pdcVanne: 'Perte de charge de la vanne'
}
